import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
  GIFT_CARD_ID_ROUTE_PARAM,
  ROUTE_GIFT_CARD_INFO,
  ROUTE_GIFT_CARDS,
} from '../../../config/routes';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../global/Button';
import { REWARD_AMOUNT_TYPES, REWARD_AMOUNT_TYPES_ID } from '../../../config/rewards';
import MailSendIcon from '../../../images/mail-send-icon.svg';
import TimerIcon from '../../../images/timer-icon.svg';
import WalletIcon from '../../../images/wallet-icon.svg';
import GiftCardCover from './GiftCardCover';

import './GiftCardContent.scss';

const MESSAGE_ITEMS = [
  {
    id: 'message-time',
    icon: TimerIcon,
    label: 'It usually takes a few seconds (but can take up to 15 minutes)',
  },
  {
    id: 'message-email',
    icon: MailSendIcon,
    label: 'You’ll receive your gift card details via email',
  },
  {
    id: 'message-wallet',
    icon: WalletIcon,
    label: 'It will be added to your wallet',
  },
];

const GiftCardContentSuccess = ({
  giftCardBrandItem,
  giftCard,
}) => {
  const history = useHistory();

  const handleOnView = useCallback(() => {
    history.push(ROUTE_GIFT_CARD_INFO.replace(GIFT_CARD_ID_ROUTE_PARAM, giftCard.uid));
  }, [history, giftCard.uid]);

  const handleOnBack = useCallback(() => {
    history.push(ROUTE_GIFT_CARDS);
  }, [history]);

  return (
    <div className="GiftCardContentSuccess">
      <GiftCardCover
        logoUrl={giftCardBrandItem.giftCardUrl}
        value={REWARD_AMOUNT_TYPES[REWARD_AMOUNT_TYPES_ID.VALUE]?.getText({
          rewardAmount: giftCard.amount,
          type: giftCard.type,
        })}
      />
      <div className="GiftCardContentSuccess__title">
        ORDER PLACED
      </div>
      <div className="GiftCardContentSuccess__desc">
        YOUR GIFT CARD IS PROCESSING NOW
      </div>
      <div className="GiftCardContentSuccess__actions">
        {MESSAGE_ITEMS.map(({ id, icon: Icon, label }) => (
          <div
            key={id}
            className="GiftCardContentSuccess__actions-action"
          >
            <img
              src={Icon}
              alt="store"
            />
            <span className="GiftCardContentSuccess__actions-action-name">
              {label}
            </span>
          </div>
        ))}
      </div>
      <Button
        type={BUTTON_TYPE.PRIMARY}
        size={BUTTON_SIZE.LARGE}
        onClick={handleOnView}
      >
        VIEW GIFT CARD IN WALLET
      </Button>
      <Button
        type={BUTTON_TYPE.SECONDARY}
        size={BUTTON_SIZE.LARGE}
        onClick={handleOnBack}
      >
        BACK TO ALL GIFT CARDS
      </Button>
    </div>
  );
};

export default GiftCardContentSuccess;
